import React from 'react'
import { Typography } from 'antd'

import IntlMessages from '../../../../util/IntlMessages'
import { DetectedPlatform } from '../types'

const { Paragraph, Text, Link } = Typography

export interface INoAccessStepProps {
  email: string
  platform: DetectedPlatform
  onChangeEmail: () => void
  onDifferentMethod: () => void
}

/**
 * Where a platform sign-in ends when the company is on Vacation Tracker but this address
 * cannot sign in to it. The reason and the request-access ask are in the banner above, as for
 * every other account the page cannot open; this step only offers the ways out.
 */
const NoAccessStep = ({ email, onChangeEmail, onDifferentMethod }: INoAccessStepProps): React.ReactElement => (
  <>
    <div className="signin-account-row">
      <Text strong data-qa="signin-resolved-email">
        {email}
      </Text>
      <Link onClick={onChangeEmail} data-qa="signin-change-email">
        <IntlMessages id="app.change" />
      </Link>
    </div>

    <Paragraph className="signin-other-options">
      <Link onClick={onDifferentMethod} data-qa="signin-different-method">
        <IntlMessages id="signin.platformStep.differentMethod" />
      </Link>
    </Paragraph>
  </>
)

export default NoAccessStep
